import * as analytics from 'analytics-core';
import getAppState from 'app-state';
import {GtagAppState} from '../types';
import config from '../config';

let isInitialized = false;

export default function init () {
    if (isInitialized) {
        return;
    }
    isInitialized = true;

    // TODO: Could config be passed through appState?
    const appState = getAppState<GtagAppState>('googleAnalytics', {});
    const enabled = analytics.getAllowAnalytics() && !!(appState.id);

    if (enabled) {
        const script = document.createElement('script');
        script.async = true;
        script.src = `${appState.apiSrc}?id=${appState.id}`;
        const currentScript = document.getElementsByTagName('script')[0];
        currentScript.parentNode.insertBefore(script, currentScript);
        window.gtag('js', new Date());
        window.gtag('config', appState.id, config);
    }
}
